/**
 * @param props
 * @returns boolean
 * @description checks for presence of `label` prop to assert between Icon and Normal Button
 */
function isIconButton(props) {
    const p = props;
    return !p.label;
}
export { isIconButton };
